import _ from 'lodash';
import { evaluateCondition, } from '../index';
function isItem(entity, itemsHash) {
    return Boolean(itemsHash[entity.id]);
}
// Evaluate condition, considering the entity's place in the menu.
// An entity can be a menu item, or a menu section.
//
// In case of evaluating a section, we will simply evaluate the
// section's condition, alongside the condition of the menu it
// belongs to. A section can belong only to a single  menu (because
// a section is a direct child of a menu).
//
// In case of evaluating a menu item, things might be a bit more
// complex. A menu-item might belong to multiple sections, which
// might belong to multiple menus (each section belongs to exactly
// one menu). In that case, we may evaluate the condition in a strict
// or loose manner.
//
// Strict mode - meaning we specify a specific section, and evaluate
// it only against this section's path in the menu. This is helpful
// when displaying menus for example.
//
// Loose mode - meaning we do not specify a section, and in case
// the item is valid in at least one of it's paths in the menu
// structure, its condition is considered truthy. This is helpful
// in case the item is in a cart - if there is a way for the item
// to be available, we would like to let the customer order it.
export function evaluateHierarchyConditions(_a) {
    var entity = _a.entity, menuRoot = _a.menuRoot, conditionParams = _a.conditionParams, sectionHint = _a.sectionHint, itemsHash = _a.itemsHash;
    // In case the entity is an item, evaluate it directly first.
    if (isItem(entity, itemsHash)) {
        var itemConditionResult = evaluateCondition(entity.condition, conditionParams);
        if (!itemConditionResult.result) {
            return itemConditionResult;
        }
    }
    // If the item has passed the initial check, or in case it's a section,
    // get all relevant paths in the menu structure (meaning the relvant list
    // of menus and sections)
    var menuAndSectionPairs = getRelevantMenuAndSectionPairs(entity, menuRoot, itemsHash, sectionHint);
    var reasons = evaluateSectionHierarchyConditions(menuAndSectionPairs, conditionParams);
    return {
        result: reasons.length === 0,
        reasons: reasons,
    };
}
function evaluateSectionHierarchyConditions(menuAndSectionPairs, conditionParams) {
    var reasons = [];
    for (var _i = 0, menuAndSectionPairs_1 = menuAndSectionPairs; _i < menuAndSectionPairs_1.length; _i++) {
        var _a = menuAndSectionPairs_1[_i], menu = _a.menu, section = _a.section;
        var menuConditionResult = evaluateCondition(menu.condition, conditionParams);
        var sectionConditionResult = evaluateCondition(section.condition, conditionParams);
        if (menuConditionResult.result && sectionConditionResult.result) {
            return [];
        }
        reasons = menuConditionResult.reasons.concat(sectionConditionResult.reasons);
    }
    return reasons;
}
function getSectionsContainingItem(item, menuRoot) {
    var itemFoundInSections = [];
    for (var _i = 0, _a = menuRoot.sections; _i < _a.length; _i++) {
        var aMenu = _a[_i];
        if (!aMenu.children) {
            continue;
        }
        for (var _b = 0, _c = aMenu.children; _b < _c.length; _b++) {
            var aSection = _c[_b];
            if (_.includes(aSection === null || aSection === void 0 ? void 0 : aSection.itemIds, item.id)) {
                itemFoundInSections.push({
                    menu: aMenu,
                    section: aSection,
                });
            }
        }
    }
    return itemFoundInSections;
}
function getMenuContainingSection(section, menuRoot) {
    for (var _i = 0, _a = menuRoot.sections; _i < _a.length; _i++) {
        var aMenu = _a[_i];
        if (!aMenu.children) {
            continue;
        }
        var ids = aMenu.children.map(function (child) { return child.id; });
        if (ids.includes(section.id)) {
            return { menu: aMenu, section: section };
        }
    }
    throw new Error("Unable to locate section " + section.id);
}
function getRelevantMenuAndSectionPairs(entity, menuRoot, itemsHash, filterBy) {
    var sections = isItem(entity, itemsHash)
        ? getSectionsContainingItem(entity, menuRoot)
        : [getMenuContainingSection(entity, menuRoot)];
    if (filterBy) {
        return sections.filter(function (p) { return p.section.id === filterBy.id; });
    }
    else {
        return sections;
    }
}
//# sourceMappingURL=evaluateHierarchyConditions.js.map